import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../../Modal/Store';
import AddParticipantStore from '../../Store';
import Modal from './Modal';
import { GroupParticipantsResource } from '../../../Group/GroupParticipantsStore/Types';

export interface Props {
  modalStore: ModalStore;
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
}

const SelectParticipantsModal: React.FC<Props> = ({
  modalStore,
  store,
  groupParticipantsResource,
}) => {
  switch (store.state.kind) {
    case 'error':
    case 'participants-added':
      return <></>;
    case 'ready':
    case 'new-participant':
    case 'remove-participant':
    case 'submitting':
      return (
        <Modal
          modalStore={modalStore}
          store={store}
          groupParticipantsResource={groupParticipantsResource}
          newParticipants={store.state.newParticipants}
          state={store.state}
        />
      );
  }
};

export default observer(SelectParticipantsModal);
